.alert {
  margin-top: 20px;
  width: 100%;
}
